var moment = require('moment')
var dateutils = require('./dateutils')
var firestoretable = require('./firestoretable')

const state = {
  all: [],
  headers: ['name', 'email', 'accountNumber', 'phoneNumber', 'phoneVerified', 'smsVerificationCode', 'status', 'approved', 'companyName', 'companyRegistrationNumber', 'bankName', 'bankAccountName', 'bankAccountNumber', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'demo'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  showConfirmApproveModal: false,
  showChangeUserStatusModal: false,
  showEditUserModal: false,
  editedUser: {
    name: '',
    email: '',
    accountNumber: '',
    phoneNumber: '',
    companyName: '',
    companyRegistrationNumber: '',
    bankName: '',
    bankAccountName: '',
    bankAccountNumber: '',
    isDemoAccount: ''
  },
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
}

const mutations = {
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
    // console.log('CHanged state page number to: ' + state.currentPage)
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
    // console.log('Mutated totalRows to: ' + state.totalRows)
  },
  toggleShowConfirmApproveModal: function (state, show) {
    state.showConfirmApproveModal = show
  },
  toggleShowChangeUserStatusModal: function (state, show) {
    state.showChangeUserStatusModal = show
  },
  selectTableRow: function (state, email) {
    for (let i = 0; i < state.all.length; i++) {
      if (state.all[i].email === email) {
        state.all[i]._rowVariant = 'info'
        // console.log('selected email:' + email)
      } else {
        state.all[i]._rowVariant = ''
      }
    }
  },
  toggleShowEditUserModal: function (state, show) {
    state.showEditUserModal = show
  },
  setEditedName: function (state, newName) {
    state.editedUser.name = newName
  },
  setEditedEmail: function (state, newEmail) {
    state.editedUser.email = newEmail
  },
  setEditedAccountNumber: function (state, newAccountNumber) {
    state.editedUser.accountNumber = newAccountNumber
  },
  setEditedPhoneNumber: function (state, newPhoneNumber) {
    state.editedUser.phoneNumber = newPhoneNumber
  },
  setEditedCompanyName: function (state, newCompanyName) {
    state.editedUser.companyName = newCompanyName
  },
  setEditedCompanyRegistrationNumber: function (state, newRegisNum) {
    state.editedUser.companyRegistrationNumber = newRegisNum
  },
  setEditedBankName: function (state, newBankName) {
    state.editedUser.bankName = newBankName
  },
  setEditedBankAccountName: function (state, newBankAccName) {
    state.editedUser.bankAccountName = newBankAccName
  },
  setEditedBankAccountNumber: function (state, newBankAccNumber) {
    state.editedUser.bankAccountNumber = newBankAccNumber
  },
  setIsDemoAccount: function (state, isDemoAccount) {
    state.editedUser.isDemoAccount = isDemoAccount
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  },
  toggleDisabledPagination: function (state, show) {
    state.disabledPagination = show
  }
}

const getters = {
  getAll: function (state, getters, rootState) {
    return state.all
  },
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  }
}

const actions = {
  showAllInvoices (context, payload) {
    context.state.all = []
    // context.state.headers = []

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    context.commit('toggleDisabledPagination', true)

    let queryParameters = {
      collectionName: 'users',
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: payload.orderBys,
      orderByDirection: 'desc',
      orderByFlippedDirection: 'asc'
    }

    let docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters)

    firestoretable.queryCollection(docQuery, context, queryParameters, false)

    // count total rows
    context.rootState.realtimeDb.ref('users').once('value').then(function (snapshot) {
      if (snapshot.val()) {
        context.commit('updateTotalRows', Number(snapshot.val().rowCount))
      } else {
        let firstQuery = context.rootState.firestoreDB.collection('users')
        firstQuery.get().then(function (querySnapshot) {
          context.commit('updateTotalRows', querySnapshot.docs.length)
        })
      }
    })

    // if (context.state.currentPage === 1) {
    //   let docQuery = context.rootState.firestoreDB.collection('users')
    //     .orderBy(payload.orderBys)
    //     .limit(context.state.rowsPerPage)
    //   docQuery.get().then(function (querySnapshot) {
    //     querySnapshot.forEach(function (doc) {
    //       let documentData = doc.data()
    //       let invoiceObject = {}
    //       for (let eachProp in documentData) {
    //         let propName = eachProp
    //         // console.log('eachProp: ' + eachProp)
    //         if (propName === 'createdDate' && doc.data()[eachProp]) {
    //           let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
    //           invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
    //         } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
    //           let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
    //           invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
    //         } else {
    //           invoiceObject[propName] = doc.data()[eachProp]
    //         }
    //         // context.state.headers.push(propName)
    //       }
    //       invoiceObject._rowVariant = ''
    //       context.state.all.push(invoiceObject)
    //     })
    //     context.commit('toggleShowLoadingAnimation', false)
    //     if (context.state.all.length === 0) {
    //       context.commit('toggleShowNoResult', true)
    //     }
    //   }).catch(function (err) {
    //     console.log('Error while fetching documents in invoice collection: ' + err)
    //     context.commit('toggleShowLoadingAnimation', false)

    //     context.commit('toggleshowLoadingError', true)
    //     context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    //   })
    // } else {
    //   let lastRowShown
    //   if (context.state.currentPage === 2) {
    //     lastRowShown = context.state.rowsPerPage
    //   } else {
    //     lastRowShown = ((context.state.currentPage - 1) * context.state.rowsPerPage)
    //   }
    //   console.log('lastRowShown: ' + lastRowShown)
    //   let docQuery = context.rootState.firestoreDB.collection('users')
    //     .orderBy(payload.orderBys)
    //   docQuery.get().then(function (querySnapshot) {
    //     let lastVisibleSnapshot = querySnapshot.docs[lastRowShown]

    //     let docSubQuery = context.rootState.firestoreDB.collection('users')
    //       .orderBy(payload.orderBys)
    //       .startAt(lastVisibleSnapshot)
    //       .limit(context.state.rowsPerPage)
    //     docSubQuery.get().then(function (subQuerySnapshot) {
    //       subQuerySnapshot.forEach(function (subDoc) {
    //         // console.log(subDoc.id + '=>' + subDoc.data())
    //         let documentData = subDoc.data()
    //         let invoiceObject = {}
    //         for (let eachProp in documentData) {
    //           let propName = eachProp
    //           // console.log('eachProp: ' + eachProp)
    //           // invoiceObject[propName] = subDoc.data()[eachProp]
    //           // context.state.headers.push(propName)
    //           if (propName === 'createdDate' && subDoc.data()[eachProp]) {
    //             let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
    //             invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
    //           } else if (propName === 'updatedDate' && subDoc.data()[eachProp]) {
    //             let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
    //             invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
    //           } else {
    //             invoiceObject[propName] = subDoc.data()[eachProp]
    //           }
    //         }
    //         invoiceObject._rowVariant = ''
    //         context.state.all.push(invoiceObject)
    //       })
    //       context.commit('toggleShowLoadingAnimation', false)
    //       if (context.state.all.length === 0) {
    //         context.commit('toggleShowNoResult', true)
    //       }
    //     })
    //   }).catch(function (err) {
    //     console.log('Error while fetching documents in invoice collection: ' + err)
    //     context.commit('toggleShowLoadingAnimation', false)

    //     context.commit('toggleshowLoadingError', true)
    //     context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    //   })
    // }
  },
  approveUser: function (context, payload) {
    let email = payload.email
    let docRef = context.rootState.firestoreDB.collection('users').doc(email)

    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(docRef).then(function (doc) {
        if (doc && doc.exists) {
          transaction.update(docRef, {approved: true, status: 'ACTIVE'})
        }
      })
    }).then(function () {
      console.log('user approved')
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' })
      context.commit('toggleShowConfirmApproveModal', false)
    }).catch(function (err) {
      console.error('Exception: ' + err)
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' })
      context.commit('toggleShowConfirmApproveModal', false)
    })
  },
  changeUserStatus: function (context, payload) {
    let email = payload.email
    let newStatus = payload.newStatus

    let docRef = context.rootState.firestoreDB.collection('users').doc(email)

    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(docRef).then(function (doc) {
        if (doc && doc.exists) {
          transaction.update(docRef, {status: newStatus})
        }
      })
    }).then(function () {
      console.log('user status changed')
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' })
      context.commit('toggleShowChangeUserStatusModal', false)
    }).catch(function (err) {
      console.error('Exception: ' + err)
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' })
      context.commit('toggleShowChangeUserStatusModal', false)
    })
  },
  updateUser: function (context, payload) {
    console.log('Edited user, name: ' + context.state.editedUser.name +
      ' email:' + context.state.editedUser.email +
      ' accountNumber:' + context.state.editedUser.accountNumber +
      ' phoneNumber:' + context.state.editedUser.phoneNumber +
      ' companyName:' + context.state.editedUser.companyName +
      ' companyRegistrationNumber:' + context.state.editedUser.companyRegistrationNumber +
      ' bankName:' + context.state.editedUser.bankName +
      ' bankAccountName:' + context.state.editedUser.bankAccountName +
      ' bankAccountNumber:' + context.state.editedUser.bankAccountNumber)

    let docRef = context.rootState.firestoreDB.collection('users').doc(context.state.editedUser.email)

    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(docRef).then(function (doc) {
        if (doc && doc.exists) {
          transaction.update(docRef,
            {
              name: context.state.editedUser.name,
              email: context.state.editedUser.email,
              accountNumber: context.state.editedUser.accountNumber,
              phoneNumber: context.state.editedUser.phoneNumber,
              companyName: context.state.editedUser.companyName,
              companyRegistrationNumber: context.state.editedUser.companyRegistrationNumber,
              bankName: context.state.editedUser.bankName,
              bankAccountName: context.state.editedUser.bankAccountName,
              bankAccountNumber: context.state.editedUser.bankAccountNumber,
              updatedDate: new Date(),
              updatedBy: 'admin',
              demo: context.state.editedUser.isDemoAccount
            }
          )
        }
      })
    }).then(function () {
      console.log('user updated')
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' })
      context.commit('toggleShowEditUserModal', false)
    }).catch(function (err) {
      console.error('Exception: ' + err)
      context.dispatch('showAllInvoices', { orderBys: 'createdDate' })
      context.commit('toggleShowEditUserModal', false)
    })
  },
  filterTable (context, payload) {
    // console.log('filter table:')
    // for (let i in payload) {
    //   console.log('i: ' + i + ' value:' + payload[i])
    // }
    if (!payload.email && !payload.accountNumber && !payload.status && !payload.phoneNumber && !payload.createdDate && payload.demo === false) {
      return
    }
    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)
    context.state.all = []
    context.state.detailAll = []
    context.commit('updateTotalRows', 0)

    let docQuery = context.rootState.firestoreDB.collection('users')
    for (let i in payload) {
      if (payload[i]) {
        console.log('where ' + i + '==' + payload[i])
        if (i === 'demo' && payload[i] === true) {
          docQuery = docQuery.where(i, '==', true)
        } else if (i === 'createdDate') {
          let startM = moment(payload.createdDate + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss')
          let endM = moment(payload.createdDate + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss')
          docQuery = docQuery.where('createdDate', '>=', startM.toDate()).where('createdDate', '<=', endM.toDate())
        } else if (payload[i].length > 0) {
          docQuery = docQuery.where(i, '==', payload[i])
        }
      }
    }

    if (!docQuery) {
      return
    }

    // docQuery = docQuery.limit(context.state.rowsPerPage)

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size)
      querySnapshot.forEach(function (doc) {
        // console.log(doc.id + '=>' + doc.data())
        let documentData = doc.data()
        let invoiceObject = {}
        for (let eachProp in documentData) {
          let propName = eachProp
          // console.log('eachProp: ' + eachProp)
          if (propName === 'orderDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY')
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else {
            invoiceObject[propName] = doc.data()[eachProp]
          }
        }
        invoiceObject._rowVariant = ''
        context.state.all.push(invoiceObject)
      })
      context.commit('toggleShowLoadingAnimation', false)
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true)
      }
    }).catch(function (err) {
      console.log('Error while fetching documents in invoice collection: ' + err)
      context.commit('toggleShowLoadingAnimation', false)

      context.commit('toggleshowLoadingError', true)
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/usersstoremodule.js